import { TextField } from "@mui/material";
import { errorsWaitListState, fechaFinWaitListState } from "../state/atoms";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import { useRecoilState, useRecoilValue } from "recoil";

export default function InputFechaFin() {
  const [fechaFin, setFechaFin] = useRecoilState(fechaFinWaitListState);
  const [errorsWaitList, setErrorsWaitList] =
    useRecoilState(errorsWaitListState);

  const handleChange = (e) => {
    setFechaFin(e.target.value);
    setErrorsWaitList((prev) => ({ ...prev, fechaFin: [] }));
  };

  return (
    <div>
      <InputLabelCustom htmlFor="finvig" text="Fin de Vigencia (*)" />
      <TextField
        id="finvig"
        size="small"
        style={{ width: "100%" }}
        name="finvig"
        type="date"
        value={fechaFin}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: new Date().toISOString().split("T")[0],
        }}
        variant="outlined"
        autoComplete="off"
        error={errorsWaitList.fechaFin.length > 0}
        helperText={errorsWaitList.fechaFin}
      />
    </div>
  );
}
